
// src/connects/review-card.js

import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import actions from '../actions'
import combineHOC from '../helpers/combine-hoc'
import { trackPage } from '../helpers/analytics'

export const mapStateToProps = (state)=> {
  return {
    isEnable: state.reviewSetting.isEnable,
    isFetching: state.lambdaApi.isFetching
  }
}

export const mapDispatchToProps = (dispatch, ownProps)=> {
  return {
    openSettingsPage: ()=> dispatch(actions.openUserSettingsPage('extensions')),
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps),
  translate(),
  trackPage('review-card'),
)



// WEBPACK FOOTER //
// ./src/connects/review-card.js